import React, { useState, useContext } from "react";
import { Button, TextField, Box, Typography, Paper } from "@mui/material";
import { NotificationContext } from "../redux/NotificationProvider";


const env = require('../EnvironmentVariables.json');

export default function Feedback({ onClose }) {
  const notify = useContext(NotificationContext);
  const [feedback, setFeedback] = useState("");
  //const [email, setEmail] = useState("");
  const name = localStorage.getItem("sc_name");
  const ID = localStorage.getItem("SC_Id");
  //const [showFeedback, setShowFeedback] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("Sending:", { ID, name, feedback });

    try {
      const response = await fetch(env.serverId + `/SCO/Feedback.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ID,
          name,
          feedback,
        }),
      });

      const result = await response.json();

      if (result.status === "Success") {
        notify("Thank you for your feedback!","success");
        //setEmail("");
        setFeedback("");
        if (onClose) onClose();
      } else {
        console.error("Failed to update task:", result.message);
        notify(result.message,"error");
      }
    } catch (error) {
      console.error("Submission error:", error);
      notify("Something went wrong.","error");
    }
  };

  return (
    <Box 
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        bgcolor: 'rgba(0,0,0,0.5)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper sx={{ padding: 4, width: '90%', maxWidth: 500 }}>
        <Typography variant="h6" gutterBottom>
          Share Your Feedback
        </Typography>
        <form onSubmit={handleSubmit}>
        
          <TextField
            label="Your Feedback"
            multiline
            rows={6}
            fullWidth
            required
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
          />
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
            <Button variant="outlined" onClick={onClose}>Cancel</Button>
            <Button variant="contained" type="submit">Submit</Button>
          </Box>
        </form>
      </Paper>
    </Box>
  );
}

  
    